import styles from './DownloadTracker.module.css';
import { DOWNLOADS } from '@he-novation/config/paths/modals.constants';
import { Icon } from '@he-novation/design-system/components/graphics/Icon/Icon';
import { ProgressCircle } from '@he-novation/design-system/components/widgets/ProgressCircle/ProgressCircle';
import { useAtomValue } from 'jotai';
import { type Download, downloaderAtom } from '../../../hooks/useDownloader';
import { useModal } from '../../../hooks/useModal';

export function DownloadTracker() {
    const { openModal } = useModal();
    const state = useAtomValue(downloaderAtom);
    const { total, inProgress, downloaded } = computeProgress(
        state.downloads,
        state.pending,
        state.finished
    );

    if (!total) return null;

    return (
        <>
            <ProgressCircle
                className={styles.tracker}
                total={total}
                value={inProgress + downloaded}
                onClick={() => {
                    openModal(DOWNLOADS);
                }}
            >
                <Icon icon="arrow_up" />
            </ProgressCircle>
        </>
    );
}

function computeProgress(downloads: Download[], pending: Download[], finished: Download[]) {
    const downloaded = finished.reduce((n, { size }) => n + size, 0);
    const { inProgress, inProgressTotal } = downloads.reduce(
        (acc, { size, progress }) => {
            acc.inProgress += size * progress;
            acc.inProgressTotal += size;
            return acc;
        },
        { inProgress: 0, inProgressTotal: 0 }
    );
    const total = downloaded + pending.reduce((n, { size }) => n + size, 0) + inProgressTotal;

    return { total, inProgress, downloaded };
}
